import {
  Checkbox,
  Col,
  Divider,
  Form,
  Image,
  Input,
  InputNumber,
  Modal,
  Radio,
  Row,
  Select,
} from "antd";
import React, { useEffect, useState } from "react";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import notfound from "../../assets/images/not_found.png";
import SingleImageUpload from "../../components/SingleImageUpload";
import MultipleImageUpload from "../../components/MultipleImageUpload";
import apiPath from "../../constants/apiPath";
import { handleAttr } from "../../helper/functions";
const AddForm = ({
  api,
  show,
  hide,
  data,
  refresh,
  paramsIds,
  section,
  categories,
  challenges,
}) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [pthumbnail, setThumbnail] = useState();

  const FileType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/avif",
    "image/webp",
    
  ];

  useEffect(() => {
    if (!data) return;
    console.log(data);
    form.setFieldsValue({
      ...data,
      category_id: data?.category_id?._id,
    });
    setThumbnail(data.thumbnail);
  }, [data]);

  const onCreate = (values) => {
    const { category_id, challenge_id, description, name } = values;

    const payload = {
      category_id,
      challenge_id,
      description,
      name,
    };

    payload.thumbnail = pthumbnail ? pthumbnail : "";
    setLoading(true);
    request({
      url: `${data ? api.addEdit + "/" + data._id : api.addEdit}`,
      method: data ? "PUT" : "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };
  const handleImage = (data) => {
    data.length > 0 ? setThumbnail(data[0].url) : setThumbnail("");
  };
  return (
    <Modal
      open={show}
      maskClosable={false}
      width={750}
      okText={data ? `Update` : `Add`}
      cancelText={`Cancel`}
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="tab_modal"
    >
      <Form
        id="create"
        form={form}
        onFinish={onCreate}
        layout="vertical"
        initialValues={{
          is_active: true,
          options: [{ name: "", ar_name: "" }],
        }}
      >
        <h4 className="modal_title_cls">
          {data ? `Edit ` : `Add New `}
          {section}
        </h4>
        <Row gutter={[16, 0]}>
          <Col span={24} sm={12}>
            <Form.Item
              label={<> {"Name"}</>}
              name="name"
              rules={[
                {
                  required: true,
                  message: "Name is required",
                },
                {
                  max: 200,
                  message: "Name should not contain more then 200 characters!",
                },
                {
                  min: 2,
                  message: "Name should contain at least 2 characters!",
                },
              ]}
              normalize={(value) => value.trimStart()}
            >
              <Input autoComplete="off" placeholder={`Enter Name`} />
            </Form.Item>
          </Col>

          <Col span={24} md={12}>
            <Form.Item
              label={<> {"Category Name"}</>}
              name="category_id"
              rules={[
                {
                  required: true,
                  message: "Please select the category!",
                },
              ]}
            >
              <Select
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                showSearch
                placeholder={"Select Category"}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              >
                {categories?.map((item) => (
                  <Select.Option
                    key={item._id}
                    label={item.name}
                    value={item._id}
                  >
                    {item?.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={24} sm={12}>
            <Form.Item
              label={<> {"Description"}</>}
              name="description"
              rules={[
                {
                  required: true,
                  message: "Description is required",
                },
                {
                  max: 2000,
                  message:
                    "Description should not contain more then 2000 characters!",
                },
                {
                  min: 2,
                  message: "Description should contain at least 2 characters!",
                },
              ]}
              normalize={(value) => value.trimStart()}
            >
              <Input.TextArea
                autoComplete="off"
                placeholder={`Enter Description`}
              />
            </Form.Item>
          </Col>

          <Col span={24} md={12}>
            <Form.Item
              label={<> {"Challenge Name"}</>}
              name="challenge_id"
              rules={[
                {
                  required: false,
                  message: "Please select the Challenge!",
                },
              ]}
            >
              <Select
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                showSearch
                placeholder={"Select Challenge"}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              >
                {challenges?.map((item) => (
                  <Select.Option
                    key={item._id}
                    label={item.title}
                    value={item._id}
                  >
                    {item?.title}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              className=""
              rules={[
                {
                  validator: (_, value) => {
                    if (value !== undefined && value?.length > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Thumbnail is required"));
                  },
                },
              ]}
              label={"Upload Thumbnail"}
              name="thumbnail"
            >
              <SingleImageUpload
                value={pthumbnail}
                fileType={FileType}
                imageType={"Thumbnail"}
                btnName={"Thumbnail"}
                onChange={(data) => handleImage(data)}
                isDimension={false}
                setLoading={setLoading}
              />
            </Form.Item>

            {
              <div className="mt-2 add-img-product">
                {" "}
                {pthumbnail ? (
                  <Image width={120} src={pthumbnail ?? notfound}></Image>
                ) : (
                  ""
                )}{" "}
              </div>
            }
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddForm;
